import styles from "./styles.module.css";
import spinner from "../../assets/spinner-verified.gif";

export const Loader = () => (
  <div className={styles.loaderContainer}>
      <img src={spinner} alt="loading"/>
  </div>
);
